<template>
<div>
    <footer class="footer-top">
      <div class="centered clearfix">
        <div class="footer-navigation">
          <div class="footer-links-holder">
            <h3><a href="#">Follow us:</a></h3>
        
            <ul class="footer-links">
              <a href=""><i class="fab fa-facebook-square" style="font-size: 2.5rem;"></i></a>
              <a href=""><i class="fab fa-line" style="font-size: 2.5rem;padding-left:2%"></i></a>
            </ul>
          </div>
          <div class="footer-links-holder">
            <h3><a href="#">關於我們</a></h3>
            <ul class="footer-links">
              <li><router-link tag="a" to="/aboutUs"><span>關於我們</span></router-link></li>
               <li><router-link tag="a" to="/contactUs"><span>聯絡我們</span></router-link></li>
              <!-- <li><a href="#">隱私權保護政策</a></li>
              <li><a href="#">服務條款</a></li>
              <li><a href="#">Sitemap </a></li> -->
            </ul>
          </div>
          <div class="footer-links-holder">
            <h3><a href="#">顧客服務</a></h3>
            <ul class="footer-links">
              <li><router-link tag="a" to="/orderingInstructions"><span>訂購說明</span></router-link></li>
              <!-- <li><a href="#">退換貨說明</a></li> -->
              <!-- <li><a href="#">老闆的話</a></li> -->
            </ul>
          </div>
          <div class="footer-links-holder">
            <h3><router-link tag="a" to="/contactUs"><span>聯絡我們</span></router-link></h3>
            <ul class="footer-links">
              <li class="tel"><a href="tel:04-7772515">02-1234567</a></li>
              <!-- <li class="tel"><a href="#">097970000 </a></li> -->
              <li class="time"><a href="#">周一至周五9:00-5:00<br/>六、日、國定假日休息</a></li>
            </ul>
          </div>

        </div>
        <div class="bottom-bar">
          <div class="row-left">COPYRIGHT © 2020 鱷魚工作室</div>

        </div>
      </div>
    </footer>
</div>
</template>




<script>
export default {
    name: 'Footer',
    data() {
        return {
       
        }
    }
    
}
</script>







// WEBPACK FOOTER //
// src/components/Layout/Footer.vue